import styled from "styled-components";

export const FlexColumn = styled.div<
  {
    gap?: number;
    minWidthZero?: boolean;
    minHeightZero?: boolean;
    padding?: number | string;
    alignItems?: string;
    justifyContent?: string;
    className?: string;
  } & React.HTMLAttributes<HTMLDivElement>
>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => (gap ?? 1) * 8}px;
  ${({ minWidthZero }) => (minWidthZero ? "min-width: 0;" : "")}
  ${({ minHeightZero }) => (minHeightZero ? "min-height: 0;" : "")}
  ${({ padding }) => (padding ? `padding: ${padding};` : "")};
  ${({ alignItems }) => (alignItems ? `align-items: ${alignItems};` : "")};
  ${({ justifyContent }) => (justifyContent ? `justify-content: ${justifyContent};` : "")};
`;

export const FlexRow = styled.div<
  {
    gap?: number;
    minWidthZero?: boolean;
    minHeightZero?: boolean;
    padding?: number | string;
    alignItems?: string;
    justifyContent?: string;
    className?: string;
  } & React.HTMLAttributes<HTMLDivElement>
>`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: ${({ gap }) => (gap ?? 1) * 8}px;
  ${({ minWidthZero }) => (minWidthZero ? "min-width: 0;" : "")}
  ${({ minHeightZero }) => (minHeightZero ? "min-height: 0;" : "")}
  ${({ padding }) => (padding ? `padding: ${padding};` : "")};
  ${({ alignItems }) => (alignItems ? `align-items: ${alignItems};` : "")};
  ${({ justifyContent }) => (justifyContent ? `justify-content: ${justifyContent};` : "")};
`;
